import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Container, Alert, Col, Row, Modal } from 'react-bootstrap';
import { firestore } from "../../firebase";
import { useHistory, useParams } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa'

export default function ViewCustomer() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [error, setError] = useState("");
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [nombre, setNombre] = useState("");
    const [correo, setCorreo] = useState("");
    const [telefono, setTelefono] = useState("");
    const [direccion, setDireccion] = useState("");
    const [notas, setNotas] = useState("");
    const history = useHistory();

    function getCustomer() {
        setLoading(true);
        setError("");

        const clienteQuery = firestore.collection('clientes').doc(id)
        clienteQuery.onSnapshot(querySnapshot => {
            if (!querySnapshot.exists) {
                setError("El cliente no existe");
            } else {
                const data = querySnapshot.data();
                setNombre(data.nombre);
                setCorreo(data.correo);
                setTelefono(data.telefono);
                setDireccion(data.direccion);
                setNotas(data.notas)
                setLoading(false);
            }
        })
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!nombre || !correo || !telefono || !direccion) {
            setError("Uno o más campos requeridos no llenados");
            setLoading(false);
            return null;
        }

        const editNombre = nombre.trim();
        const editCorreo = correo.trim();
        const editTelefono = telefono.trim();
        const editDireccion = direccion.trim();
        const editNotas = notas.trim();

        setNombre(editNombre);
        setCorreo(editCorreo);
        setTelefono(editTelefono);
        setDireccion(editDireccion);
        setNotas(editNotas);

        const newCustomer = {
            nombre: editNombre,
            correo: editCorreo,
            telefono: editTelefono,
            direccion: editDireccion,
            notas: editNotas
        }

        firestore.collection('clientes').doc(id).update(newCustomer)
        .then(() => {
            setShowEdit(true);
            setEditing(false);
            setLoading(false);
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);
        })
    }

    function handleDelete(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        firestore.collection('clientes').doc(id).delete()
        .then(() => {
            setShowDelete(false);
            setLoading(false);
            history.push("/customers");
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setShowDelete(false);
            setLoading(false);
        })
    }

    useEffect(() => {
        getCustomer();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "500px"}}>
                <h2 className="text-center mt-3 mb-4">Ver Cliente</h2>
                <Modal show={showEdit} onHide={() => setShowEdit}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se editó el cliente correctamente
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowEdit(false)}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showDelete} onHide={() => setShowDelete(false)}>
                    <Modal.Header>
                        <Modal.Title>Aviso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Desea borrar el cliente? Desaparecerá del sistema completamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleDelete}>
                            Aceptar
                        </Button>
                        <Button variant="secondary" onClick={() => setShowDelete(false)}>
                            Cancelar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-nombre">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={nombre}
                                    onChange={e => setNombre(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-correo">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control 
                                    type="email" 
                                    value={correo}
                                    onChange={e => setCorreo(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-telefono">
                                    <Form.Label>Número de teléfono</Form.Label>
                                    <Form.Control 
                                    type="tel" 
                                    value={telefono}
                                    onChange={e => setTelefono(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-direccion">
                                    <Form.Label>Dirección</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={2}
                                    value={direccion}
                                    onChange={e => setDireccion(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-notas">
                                    <Form.Label>Notas (opcional)</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={3}
                                    value={notas}
                                    onChange={e => setNotas(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={12}>
                                    <Button className='mx-1' disabled={loading || !editing} type="submit">
                                        Guardar
                                    </Button>
                                    <Button className='mx-1' disabled={loading || !editing} variant="danger"
                                    onClick={() => {setEditing(false); getCustomer();}}>
                                        Cancelar
                                    </Button>
                                    <Button className='m-1 py-0 px-1' disabled={loading} variant="link" style={{fontSize: "1.65rem"}}
                                    onClick={() => setEditing(true)}>
                                        <span><FaEdit/></span>
                                    </Button>
                                    <Button className='m-1 py-0 px-1' disabled={loading} variant="link" style={{fontSize: "1.65rem"}}
                                    onClick={() => setShowDelete(true)}>
                                        <span><FaTrashAlt/></span>
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}